
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMCases } from "@/store";
import { REJECTED_BY_HO_OA_STATUS } from "@/constants/services";

@Component
export default class RejectHOPopUp extends Vue {
  @Prop({ type: Boolean, default: true }) readonly visible!: boolean;

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get text() {
    return this.$tc("text");
  }

  get buttonCaption() {
    return this.$tc("buttons.ok");
  }

  showPopup = false;

  @Watch("visible", { immediate: true })
  visibleChanged(val: boolean) {
    if (val) {
      this.open();
    } else {
      this.showPopup = false;
    }
  }

  open() {
    this.showPopup = false;

    this.$nextTick(() => {
      this.showPopup = true;
    });
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  async confirm() {
    try {
      await this.axios.put(API_ROUTES.CASE_EXPERT_HO_REJECT(this.serviceId));

      this.$emit("confirm");

      this.$root.$emit("update-profile");

      SMCases.setOnlineApplicationStatus(REJECTED_BY_HO_OA_STATUS);
    } finally {
      this.close();
    }
  }
}
